var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 3a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M.997 8.303C1.113 7.218 2.235 6.25 3.75 6.25c.928 0 1.731.373 2.225.92l.007.006.007.008.133.135c-.884.521-1.51 1.364-1.62 2.378a.5.5 0 0 0 .995.106C5.613 8.718 6.735 7.75 8.25 7.75s2.637.968 2.753 2.053a.5.5 0 0 0 .994-.106C11.813 7.978 10.14 6.75 8.25 6.75c-.392 0-.774.053-1.136.152L6.71 6.49c-.698-.766-1.775-1.24-2.96-1.24C1.86 5.25.187 6.478.003 8.197a.5.5 0 0 0 .994.106M8 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
    clipRule: "evenodd"
  })));
});
const SvgUserssmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserssmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01IDNDNSAzLjgyODQzIDQuMzI4NDMgNC41IDMuNSA0LjVDMi42NzE1NyA0LjUgMiAzLjgyODQzIDIgM0MyIDIuMTcxNTcgMi42NzE1NyAxLjUgMy41IDEuNUM0LjMyODQzIDEuNSA1IDIuMTcxNTcgNSAzWk0wLjk5NzIwNyA4LjMwMzE2QzEuMTEzMjIgNy4yMTgyOCAyLjIzNDk5IDYuMjUgMy43NTAwNCA2LjI1QzQuNjc4MyA2LjI1IDUuNDgwOTUgNi42MjI4OCA1Ljk3NTQzIDcuMTY5MDZMNS45ODIxNiA3LjE3NjVMNS45ODkxOSA3LjE4MzY3TDYuMTIxOTIgNy4zMTg5NEM1LjIzODEzIDcuODQwMDUgNC42MTEyMyA4LjY4MzIxIDQuNTAyODMgOS42OTY4NEM0LjQ3MzQ3IDkuOTcxNDEgNC42NzIyNiAxMC4yMTc4IDQuOTQ2ODQgMTAuMjQ3MkM1LjIyMTQxIDEwLjI3NjUgNS40Njc4IDEwLjA3NzcgNS40OTcxNyA5LjgwMzE2QzUuNjEzMTggOC43MTgyOCA2LjczNDk1IDcuNzUgOC4yNSA3Ljc1QzkuNzY1MDUgNy43NSAxMC44ODY4IDguNzE4MjggMTEuMDAyOCA5LjgwMzE2QzExLjAzMjIgMTAuMDc3NyAxMS4yNzg2IDEwLjI3NjUgMTEuNTUzMiAxMC4yNDcyQzExLjgyNzcgMTAuMjE3OCAxMi4wMjY1IDkuOTcxNDEgMTEuOTk3MiA5LjY5Njg0QzExLjgxMzQgNy45Nzg0NyAxMC4xMzk1IDYuNzUgOC4yNSA2Ljc1QzcuODU4MTcgNi43NSA3LjQ3NTYxIDYuODAyODMgNy4xMTM2OSA2LjkwMTlMNi43MDk3NCA2LjQ5MDE5QzYuMDExNiA1LjcyMzgyIDQuOTM1NDMgNS4yNSAzLjc1MDA0IDUuMjVDMS44NjA1NSA1LjI1IDAuMTg2NjMgNi40Nzg0NyAwLjAwMjg3NjA2IDguMTk2ODRDLTAuMDI2NDg1OSA4LjQ3MTQxIDAuMTcyMyA4LjcxNzggMC40NDY4NzcgOC43NDcxN0MwLjcyMTQ1NCA4Ljc3NjUzIDAuOTY3ODQ1IDguNTc3NzQgMC45OTcyMDcgOC4zMDMxNlpNOCA2QzguODI4NDMgNiA5LjUgNS4zMjg0MyA5LjUgNC41QzkuNSAzLjY3MTU3IDguODI4NDMgMyA4IDNDNy4xNzE1NyAzIDYuNSAzLjY3MTU3IDYuNSA0LjVDNi41IDUuMzI4NDMgNy4xNzE1NyA2IDggNloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";